import React from 'react';
import { useTranslation } from 'react-i18next';

import ConsumerHeader from '../../../../consumer-page/consumer-header/ConsumerHeader';
import RequestFullAccessButton from '../../request-full-access-button/RequestFullAccessButton';

import scss from './RecreateImagesHeader.module.scss';

function RecreateImagesHeader() {
  const { t } = useTranslation('demoAdImages');
  return (
    <ConsumerHeader
      AdditionalActions={
        <div className={scss.actionsWrapper}>
          <RequestFullAccessButton />
        </div>
      }>
      <div className={scss.projectName}>
        <h3>{t('reCreateYourAd')}</h3>
      </div>
    </ConsumerHeader>
  );
}

export default RecreateImagesHeader;
